import React, { useEffect } from "react"
import { Backdrop, CircularProgress, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import AdminAccessOrganizationForm from "./AdminAccessOrganizationForm"
import AdminAccessOrganizationInfoPanel from "./AdminAccessOrganizationInfoPanel"
import AdminAccessOrganizationUsersTable from "./AdminAccessOrganizationUsersTable"
import {
  clearAdminAccessMessages,
  enableAdminAccessOrganizationBaseAccess,
  fetchAdminApplications,
  fetchApplicationInstance,
  searchOrganizationByCuit,
  setAdminAccessAppCode,
  setAdminAccessCuit,
  setAdminAccessOrganizationFinishDate,
  setAdminAccessSelectedUser,
} from "../../../redux/actions/adminAccessUserActions"
import { isAccessGrantedAndActive } from "../../../utils/adminAccessUserHelpers"
import useStyles from "./useStyles"
import InfoIcon from "@mui/icons-material/Info"
import { BoxModules } from "./Boxes/Modules"
import { BoxTopes } from "./Boxes/Params"

export const AdminAccessOrganizationSearchContent = ({ applicationCode }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const classes = useStyles()

  const {
    cuit,
    orgFinishDate,
    organization,
    orgAccess,
    applicationInstanceId,
    organizationUsers,
    hasSearchedOrganization,
    validatingOrganization,
    loadingOrgContext,
    enablingOrganizationAccess,
    loadingModules,
    error,
    successMessage,
    modules,
    loadingParams,
    params,
    applicationsRoutes,
    loadingAppsRoutes,
    appCode
  } = useSelector((state) => state.adminAccessUser)

  const handleCuitChange = (value) => {
    dispatch(setAdminAccessCuit(value))
  }

  const handleSearch = async () => {
    try {
      dispatch(clearAdminAccessMessages())
      await dispatch(searchOrganizationByCuit(cuit))
    } catch (error) {
      return null
    }
  }

  const handleOrgFinishDateChange = (value) => {
    dispatch(setAdminAccessOrganizationFinishDate(value))
  }

  const handleRefresh = () => {
    dispatch(fetchApplicationInstance(applicationInstanceId))
  }

  const handleEnableBaseAccess = async () => {
    try {
      await dispatch(enableAdminAccessOrganizationBaseAccess())
    } catch (error) {
      return null
    }
  }

  const handleConfigureUser = (user) => {
    dispatch(setAdminAccessSelectedUser(user))
    navigate(`/admin-access-user-app-content/application${applicationCode}/user/${user?.userId}`)
  }

  const applicationName = applicationsRoutes.find((app) => app.application_code === applicationCode)?.application_name ?? ""


  useEffect(() => {
    if (applicationInstanceId) {
      handleRefresh()
    }
  }, [applicationInstanceId])

  useEffect(() => {
    if (appCode !== applicationCode) {
      dispatch(setAdminAccessAppCode(applicationCode))
      if (!applicationsRoutes || !applicationsRoutes.length) dispatch(fetchAdminApplications())

      if (cuit && cuit !== "") {
        dispatch(clearAdminAccessMessages())
        handleCuitChange("")
      }
    }
  }, [applicationCode])

  const hasOrganization = Boolean(organization?.organizationId)
  const hasOrgBaseAccess = isAccessGrantedAndActive(orgAccess)
  const loadingSearch = validatingOrganization || loadingOrgContext


  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingOrgContext || loadingAppsRoutes || loadingModules}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Configuración de acceso: <strong>{applicationName}</strong>
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: "2rem", color: "#00a78f", marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá habilitar el acceso base a la organización y
          configurar usuarios específicos para el acceso a la aplicación.
        </Typography>
      </div>
      <AdminAccessOrganizationForm
        cuit={cuit}
        orgFinishDate={orgFinishDate}
        hasOrganization={hasOrganization}
        hasSearchedOrganization={hasSearchedOrganization}
        hasOrgBaseAccess={hasOrgBaseAccess}
        validatingOrganization={validatingOrganization}
        loadingOrgContext={loadingOrgContext}
        enablingOrganizationAccess={enablingOrganizationAccess}
        organizationUsers={organizationUsers}
        error={error}
        successMessage={successMessage}
        onCuitChange={handleCuitChange}
        onSearch={handleSearch}
        onOrgFinishDateChange={handleOrgFinishDateChange}
        onEnableBaseAccess={handleEnableBaseAccess}
      />

      {hasOrganization ? (
        <div style={{ marginTop: '5%', marginLeft: '5%' }}>
          <AdminAccessOrganizationInfoPanel
            organization={organization}
            orgAccess={orgAccess}
            applicationInstanceId={applicationInstanceId}
            organizationUsers={organizationUsers}
            hasOrganization={hasOrganization}
            successMessage={successMessage}
            orgFinishDate={orgFinishDate}
            onOrgFinishDateChange={handleOrgFinishDateChange}
            enablingOrganizationAccess={enablingOrganizationAccess}
            onEnableBaseAccess={handleEnableBaseAccess}
            validatingOrganization={validatingOrganization}
            loadingOrgContext={loadingOrgContext}
            error={error}

          />
        </div>
      ) : null}
      {hasOrganization && hasOrgBaseAccess ? (
        <div style={{
          marginTop: '2%',
          width: '90%',
          marginLeft: '5%',

          // marginBottom: '5%',
        }}>
          {!loadingModules && modules && applicationInstanceId ? (
            <div style={{
              background: '#f9f9f9',
              boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
              borderRadius: 10,
            }}>
              <BoxModules
                modules={modules}
                appCode={applicationCode}
                refresh={handleRefresh}
                applicationInstanceId={applicationInstanceId}
              />

            </div>
          ) : null}
          {!loadingParams && params && applicationInstanceId ? (
            <div style={{
              background: '#f9f9f9',
              boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
              borderRadius: 10,
            }}>

              <BoxTopes
                parameters={params}
                appCode={applicationCode}
                refresh={handleRefresh}
                applicationInstanceId={applicationInstanceId}
              />
            </div>
          ) : null}
          <AdminAccessOrganizationUsersTable
            users={organizationUsers}
            loading={loadingSearch}
            applicationInstanceId={applicationInstanceId}
            onConfigureUser={handleConfigureUser}
          />

        </div>
      ) : null}

    </div >
  )
}

export default AdminAccessOrganizationSearchContent
